(()=>{
  'use strict';
  if(window.__rkReviewsInstalled){document.dispatchEvent(new Event('rk:reviews:refresh'));return;}
  window.__rkReviewsInstalled=true;
  const instances=new Map();
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root){
    if(instances.has(root))return;
    const rail=root.querySelector('[data-rk-review-rail]');
    const cards=[...root.querySelectorAll('[data-rk-review-card]')];
    const controls=root.querySelector('[data-rk-review-controls]');
    const previous=root.querySelector('[data-rk-review-prev]');
    const next=root.querySelector('[data-rk-review-next]');
    const position=root.querySelector('[data-rk-review-position]');
    if(!rail||!cards.length||!controls)return;
    const controller=new AbortController();
    let frame=0,announcement=0;
    function geometry(){
      const first=cards[0].getBoundingClientRect();
      const second=cards[1]?.getBoundingClientRect();
      const step=second?second.left-first.left:first.width;
      if(step<=0)return{step:1,capacity:1,index:0,max:0};
      const capacity=Math.max(1,Math.round((rail.clientWidth+Math.max(0,step-first.width))/step));
      const index=Math.max(0,Math.min(cards.length-1,Math.round(rail.scrollLeft/step)));
      return{step,capacity,index,max:Math.max(0,rail.scrollWidth-rail.clientWidth)};
    }
    function paint(){
      frame=0;
      const g=geometry();
      const overflow=g.max>3;
      controls.hidden=!overflow;
      previous.disabled=rail.scrollLeft<=2;
      next.disabled=rail.scrollLeft>=g.max-2;
      clearTimeout(announcement);
      announcement=setTimeout(()=>{
        const end=Math.min(cards.length,g.index+g.capacity);
        const label=g.capacity===1?`${g.index+1} / ${cards.length}`:`${g.index+1}–${end} / ${cards.length}`;
        if(position.textContent!==label)position.textContent=label;
      },140);
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(paint)}
    function move(index){
      const g=geometry();
      const left=Math.max(0,Math.min(g.max,index*g.step));
      rail.scrollTo({left,behavior:reduceMotion.matches?'auto':'smooth'});
      schedule();
    }
    function listen(target,type,handler,options={}){target.addEventListener(type,handler,{...options,signal:controller.signal})}
    listen(previous,'click',()=>move(geometry().index-1));
    listen(next,'click',()=>move(geometry().index+1));
    listen(rail,'scroll',schedule,{passive:true});
    listen(rail,'keydown',event=>{
      if(event.target!==rail)return;
      if(event.key==='ArrowLeft'){event.preventDefault();move(geometry().index-1)}
      else if(event.key==='ArrowRight'){event.preventDefault();move(geometry().index+1)}
      else if(event.key==='Home'){event.preventDefault();move(0)}
      else if(event.key==='End'){event.preventDefault();move(cards.length-1)}
    });
    let observer;
    if('ResizeObserver'in window){observer=new ResizeObserver(schedule);observer.observe(rail)}
    else listen(window,'resize',schedule,{passive:true});
    const cleanup=()=>{controller.abort();observer?.disconnect();cancelAnimationFrame(frame);clearTimeout(announcement);instances.delete(root)};
    instances.set(root,{cleanup,reveal(card){const index=cards.indexOf(card);if(index>=0)move(index);}});
    paint();
  }
  function boot(scope=document){scope.querySelectorAll('[data-rk-reviews]').forEach(mount)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('rk:reviews:refresh',()=>boot());
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('[data-rk-review-card]');if(card){instances.get(card.closest('[data-rk-reviews]'))?.reveal(card);}});
  document.addEventListener('shopify:section:unload',event=>{instances.forEach((entry,root)=>{if(event.target.contains(root))entry.cleanup()})});
})();
